var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "diet-record" }, [
    _c("div", { staticClass: "record-header" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "time-tabs" },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.value,
              class: ["tab-btn", { active: _vm.activeTab === tab.value }],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange(tab.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(tab.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "record-content" }, [
      _c("div", { staticClass: "left-stats" }, [
        _vm._m(1),
        _c("div", { staticClass: "stat-number" }, [
          _c("span", { staticClass: "number" }, [
            _vm._v(_vm._s(_vm.totalCount)),
          ]),
          _c("span", { staticClass: "unit" }, [_vm._v("次")]),
        ]),
        _c("div", { staticClass: "stat-label" }, [_vm._v("忌口食材")]),
        _c("div", { staticClass: "stat-sublabel" }, [_vm._v("食用次数")]),
      ]),
      _c(
        "div",
        { staticClass: "food-list" },
        [
          _vm._l(_vm.displayList, function (food, index) {
            return _c("div", { key: index, staticClass: "food-item" }, [
              _c("div", { staticClass: "food-image" }, [
                food.image
                  ? _c("img", { attrs: { src: food.image, alt: food.name } })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/icon/zanwu.png"),
                        alt: "",
                      },
                    }),
                food.tags && food.tags.length
                  ? _c(
                      "div",
                      { staticClass: "food-tags" },
                      _vm._l(food.tags, function (tag, idx) {
                        return _c(
                          "span",
                          {
                            key: idx,
                            staticClass: "food-tag",
                            style: { backgroundColor: tag.color || "#ff6b6b" },
                          },
                          [_vm._v(" " + _vm._s(tag.label) + " ")]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "food-count" }, [
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(food.count)),
                ]),
                _c("span", { staticClass: "count-unit" }, [_vm._v("次")]),
              ]),
              _c("div", { staticClass: "food-name" }, [
                _vm._v(_vm._s(food.name)),
              ]),
            ])
          }),
          _vm.displayList.length === 0
            ? _c("div", { staticClass: "empty-text" }, [_vm._v(" 暂无记录 ")])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-wrapper" }, [
      _c("div", { staticClass: "title-bar" }),
      _c("h3", { staticClass: "title" }, [_vm._v("饮食记录")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "warning-icon" }, [
      _c("img", {
        staticStyle: { width: "60px" },
        attrs: { src: require("@/assets/icon/jikou.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }